module.exports={
	"Form": "DocumentEditManifest",
	"Descriptors": {
		"DocumentDetails.Name": {
			"Name": "Name",
			"Hash": "EditDocumentName",
			"DataType": "String",
			"PictForm": {
				"Row": "1",
				"Section": "DocumentEdit",
				"Group": "DocumentEdit"
			}
		},
		"DocumentDetails.DocumentDate": {
			"Name": "Document Date",
			"Hash": "EditDocumentDate",
			"DataType": "Date",
			"PictForm": {
				"Row": "1",
				"Section": "DocumentEdit",
				"Group": "DocumentEdit"
			}
		}
	},
	"Sections": [
		{
			"Name": "Document Edit",
			"Hash": "DocumentEdit",
			"Solvers": [],
			"ShowTitle": false,
			"Groups": [
				{
					"Name": "Document Edit",
					"Hash": "DocumentEdit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
